<div [formGroup]="form">
    <div class="form-container form-container-vertical">
        <div>
            <label>Entry Title</label>
            <input pInputText formControlName="title" />
        </div>
        <div>
            <label>Entry Author</label>
            <input pInputText formControlName="author" />
        </div>
        <div>
            <p-selectbutton formControlName="entryType" [allowEmpty]="false" [options]="entryTypes()"
                optionLabel="label" optionValue="value" />
        </div>
        @if(form.controls.entryType.value === 'picture') {
        <div>
            <label>Entry</label>
            <app-prose-mirror editorType="main-site-content" formControlName="entry"></app-prose-mirror>
        </div>
        }
        @else {
        <div>
            <label>Video URL</label>
            <input pInputText formControlName="videoUrl" />
        </div>
        }
    </div>
    @if(form.controls.entryType.value === 'picture') {
    <div class="flex flex-col gap-2 items-center w-full">
        @if (!this.imageUrl()) {
        <div class="text-error">No Collages!</div>
        <p-button label="Select Image" severity="info" (click)="fileInput.click()"><fa-icon
                [icon]="icons.ppmSolid.upload"></fa-icon></p-button>
        <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)" accept="image/*">

        }

        @if(imageUrl()) {
        <img [src]="imageUrl()" class="uploaded-image">
        <p-button label="Remove image" severity="danger" (click)="removeImage()"></p-button>
        }
    </div>
    }
    @else if(form.controls.entryType.value === 'video') {

        @if(videoId()) {
            <app-youtube-embed [youtubeVideoId]="videoId()!"></app-youtube-embed>
        }
        @else {
            <p>Please enter a youtube video URL</p>
        }
    }
    <div class="flex justify-end gap-2 mt-4">
        <p-button label="Cancel" severity="secondary" (click)="cancel.emit()"></p-button>
        <app-save-button (saveClick)="saveEntry()"></app-save-button>
    </div>

    <style>
        .image-container {
            margin: 10px 0;
        }

        .uploaded-image {
            max-width: 400px;
            max-height: 300px;
            width: auto;
            height: auto;
            object-fit: contain;
            border: 1px solid #ddd;
            border-radius: 4px;
            display: block;
            margin-bottom: 10px;
        }
    </style>
</div>